export default __webpack_public_path__ + "static/media/walla.be058b20.svg";